// extracted by mini-css-extract-plugin
export default {"seoWrapper":"seoWrapper__ZjEwM","seoContent":"seoContent__YTdiO"};